/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsBoardFinderViewProps } from '../../../modules/hosports-board-finder/./hosports-board-finder';
import BoardFinder from './../../../baseComponents/board-finder/./board-finder';

class HosportsBoardFinder extends React.Component<IHosportsBoardFinderViewProps> {
  render() {
    const { config } = this.props;

    return (
        <BoardFinder type={config.type} />
    );
  }
}

export default HosportsBoardFinder;
